import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.023 9.34794H21.015L17.834 6.16494C16.8099 5.14081 15.5342 4.40433 14.1352 4.02955C12.7362 3.65476 11.2632 3.65487 9.86428 4.02986C8.46534 4.40486 7.18977 5.14153 6.16581 6.16581C5.14184 7.19009 4.40557 8.46588 4.03101 9.86494M2.98501 19.6439V14.6519M2.98501 14.6519H7.97701M2.98501 14.6519L6.16501 17.8349C7.18912 18.8591 8.4648 19.5955 9.8638 19.9703C11.2628 20.3451 12.7358 20.345 14.1347 19.97C15.5337 19.595 16.8092 18.8584 17.8332 17.8341C18.8572 16.8098 19.5934 15.534 19.968 14.1349M21.015 4.35594V9.34594",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }